(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pawloom-header"]) return;
  try {
    
  (() => {
    const initializeHeader = (root) => {
      if (!root || root.dataset.pawloomHeaderReady === 'true') return;
      root.dataset.pawloomHeaderReady = 'true';
      const drawer = root.querySelector('[data-pawloom-drawer]');
      const closeButtons = root.querySelectorAll('[data-pawloom-drawer-close]');
      const dropdowns = root.querySelectorAll('[data-pawloom-dropdown]');
      const dropdownTriggers = root.querySelectorAll('[data-pawloom-dropdown-trigger]');
      const homeLinks = root.querySelectorAll('[data-pawloom-home-link]');
      const search = root.querySelector('[data-pawloom-search]');
      const dropdownCloseTimers = new WeakMap();

      const clearDropdownClose = (dropdown) => {
        const closeTimer = dropdownCloseTimers.get(dropdown);
        if (closeTimer) window.clearTimeout(closeTimer);
        dropdownCloseTimers.delete(dropdown);
      };

      const setDropdownState = (dropdown, isOpen) => {
        if (!dropdown) return;

        if (dropdown.classList.contains('pawloom-site-header__dropdown--button')) {
          dropdown.classList.toggle('is-open', isOpen);
          if (!isOpen) delete dropdown.dataset.pawloomDropdownPinned;
          const trigger = dropdown.querySelector('[data-pawloom-dropdown-trigger]');
          if (trigger) trigger.setAttribute('aria-expanded', String(isOpen));
          return;
        }

        dropdown.open = isOpen;
      };

      const setDrawerState = () => {
        document.documentElement.classList.toggle('pawloom-drawer-open', Boolean(drawer && drawer.open));
      };

      if (drawer) {
        drawer.addEventListener('toggle', setDrawerState);
        closeButtons.forEach((button) => {
          button.addEventListener('click', () => {
            drawer.open = false;
          });
        });
      }

      homeLinks.forEach((link) => {
        link.addEventListener('click', (event) => {
          const destination = new URL(link.href, window.location.origin);

          if (destination.pathname !== window.location.pathname) return;

          event.preventDefault();
          window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
        });
      });

      dropdownTriggers.forEach((trigger) => {
        const dropdown = trigger.closest('[data-pawloom-dropdown]');
        if (!dropdown) return;

        trigger.addEventListener('click', () => {
          const isPinnedOpen = dropdown.classList.contains('is-open') && dropdown.dataset.pawloomDropdownPinned === 'true';
          clearDropdownClose(dropdown);

          if (isPinnedOpen) {
            setDropdownState(dropdown, false);
            return;
          }

          dropdown.dataset.pawloomDropdownPinned = 'true';
          setDropdownState(dropdown, true);
        });

        dropdown.addEventListener('pointerenter', () => {
          clearDropdownClose(dropdown);
          setDropdownState(dropdown, true);
        });

        dropdown.addEventListener('pointerleave', () => {
          if (dropdown.dataset.pawloomDropdownPinned === 'true') return;

          clearDropdownClose(dropdown);
          dropdownCloseTimers.set(
            dropdown,
            window.setTimeout(() => {
              if (!dropdown.matches(':hover') && !dropdown.contains(document.activeElement)) {
                setDropdownState(dropdown, false);
              }
            }, 220)
          );
        });

        dropdown.addEventListener('focusout', () => {
          window.requestAnimationFrame(() => {
            if (!dropdown.contains(document.activeElement)) {
              clearDropdownClose(dropdown);
              setDropdownState(dropdown, false);
            }
          });
        });
      });

      root.addEventListener('click', (event) => {
        if (event.target.closest('[data-pawloom-dropdown]')) return;
        dropdowns.forEach((dropdown) => {
          clearDropdownClose(dropdown);
          setDropdownState(dropdown, false);
        });
      });

      root.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        dropdowns.forEach((dropdown) => {
          clearDropdownClose(dropdown);
          setDropdownState(dropdown, false);
        });
        if (search) search.open = false;
        if (drawer) drawer.open = false;
      });
    };

    document.querySelectorAll('[data-pawloom-header]').forEach(initializeHeader);
    document.addEventListener('shopify:section:load', (event) => {
      initializeHeader(event.target.querySelector('[data-pawloom-header]'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pawloom-process-timeline"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeProcess = (root) => {
      if (!root || root.dataset.pawloomProcessReady === 'true') return;
      root.dataset.pawloomProcessReady = 'true';

      const panels = Array.from(root.querySelectorAll('[data-pawloom-process-panel]'));
      const tabs = Array.from(root.querySelectorAll('[data-pawloom-process-tab]'));
      const previous = root.querySelector('[data-pawloom-process-previous]');
      const next = root.querySelector('[data-pawloom-process-next]');
      let currentIndex = 0;

      const selectStep = (index, moveFocus = false) => {
        if (!tabs.length) return;
        currentIndex = Math.max(0, Math.min(index, tabs.length - 1));
        panels.forEach((panel, panelIndex) => {
          const active = panelIndex === currentIndex;
          panel.classList.toggle('is-active', active);
          panel.setAttribute('aria-hidden', active ? 'false' : 'true');
        });
        tabs.forEach((tab, tabIndex) => {
          const active = tabIndex === currentIndex;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
          tab.setAttribute('tabindex', active ? '0' : '-1');
          if (active && moveFocus) {
            tab.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
            tab.focus();
          }
        });
        if (previous) previous.disabled = currentIndex === 0;
        if (next) next.disabled = currentIndex === tabs.length - 1;
      };

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => selectStep(index));
        tab.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowRight') {
            event.preventDefault();
            selectStep(currentIndex + 1, true);
          }
          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            selectStep(currentIndex - 1, true);
          }
          if (event.key === 'Home') {
            event.preventDefault();
            selectStep(0, true);
          }
          if (event.key === 'End') {
            event.preventDefault();
            selectStep(tabs.length - 1, true);
          }
        });
      });

      if (previous) previous.addEventListener('click', () => selectStep(currentIndex - 1));
      if (next) next.addEventListener('click', () => selectStep(currentIndex + 1));

      document.addEventListener('shopify:block:select', (event) => {
        const selectedPanel = root.querySelector(`[data-pawloom-block-id="${event.detail.blockId}"]`);
        if (!selectedPanel) return;
        selectStep(panels.indexOf(selectedPanel));
      });

      selectStep(0);
    };

    document.querySelectorAll('[data-pawloom-process]').forEach(initializeProcess);
    document.addEventListener('shopify:section:load', (event) => {
      initializeProcess(event.target.querySelector('[data-pawloom-process]'));
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
